<template>
  <div id="payment-cancelled" class="cancelled-page">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="text-center">
          <div class="py-12">
            <!-- Cancelled Icon -->
            <div class="cancelled-icon mb-6">
              <i class="fas fa-times-circle text-6xl text-warning"></i>
            </div>
            
            <!-- Cancelled Message -->
            <h1 class="text-3xl font-bold text-warning mb-4">
              Payment Cancelled
            </h1>
            
            <p class="text-lg text-gray-600 mb-6">
              Your payment was cancelled. No charges have been made to your account.
            </p>
            
            <!-- Additional Message -->
            <div class="additional-message mb-6">
              <p class="text-gray-500">
                {{ message || 'You can try again anytime or contact our support team if you need assistance.' }}
              </p>
            </div>
            
            <!-- Action Buttons -->
            <div class="action-buttons">
              <vs-button 
                color="primary" 
                size="large"
                @click="goToCatalog"
                class="mr-4">
                <i class="fas fa-shopping-cart mr-2"></i>
                Try Again
              </vs-button>
              
              <vs-button 
                color="secondary" 
                size="large"
                @click="goToDashboard">
                <i class="fas fa-home mr-2"></i>
                Go to Dashboard
              </vs-button>
            </div>
            
            <!-- Support Info -->
            <div class="support-info mt-8">
              <p class="text-sm text-gray-500">
                Need help? Contact our support team for assistance with your purchase.
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCancelled',
  data() {
    return {
      message: ''
    };
  },
  mounted() {
    // Get message from query parameters if available
    const urlParams = new URLSearchParams(window.location.search);
    this.message = urlParams.get('message') || '';
  },
  methods: {
    goToCatalog() {
      this.$router.push('/licensing/catalog');
    },
    
    goToDashboard() {
      this.$router.push('/pages/home');
    }
  }
};
</script>

<style scoped>
.cancelled-page {
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.cancelled-icon {
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.additional-message {
  max-width: 500px;
  margin: 0 auto;
}

.action-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.support-info {
  max-width: 400px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .cancelled-page {
    padding: 1rem;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .action-buttons .vs-button {
    width: 100%;
    max-width: 300px;
  }
}
</style>
